<div class="p-0 apercu-wrap" style="height: 65vh; margin-bottom: 15px">
    <div class="pt-0 pr-0">
        <table class="table align-middle mb-0">
            <thead class="custom-thead">
                <tr class="align-middle" style="color: #2f2b3de5">
                    <th>LABEL</th>
                    <th class="text-end">VALEUR</th>
                </tr>
            </thead>
            <tbody style="color: #2f2b3de5; font-size: 15px">
                <tr *ngIf="isLoading">
                    <td colspan="2" class="text-center py-4">
                        <span class="spinner-border spinner-border-sm text-primary" role="status"></span>
                        <span class="ml-2">Chargement de l’aperçu…</span>
                    </td>
                </tr>
                <tr
                    *ngFor="let row of apercuData"
                    style="font-size: 15px; border-bottom: 1px solid #dee2e6"
                >
                    <td
                        style="border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6"
                        class="align-middle"
                    >
                        {{ row.label }}
                    </td>
                    <td
                        style="border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6"
                        class="text-end text-primary fw-bold"
                    >
                        {{ row.value | number : '1.2-3' }} TND
                    </td>
                </tr>
                <tr *ngIf="!isLoading && apercuData.length === 0">
                    <td colspan="2" class="text-center py-4 text-muted">
                        Pas de données pour cet entrepôt.
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="mt-2 d-flex justify-content-end" *ngIf="!isLoading && apercuData.length > 0">
        <div class="border-dashed rounded text-center total-box">
            <div class="total-number">{{ total | number : '1.2-3' }} TND</div>
            <p class="size15 mb-0">Total</p>
        </div>
    </div>
</div>
